import type { GetCustomRoleByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetCustomRoleByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomRoleByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCustomRoleByIdArgs = {
  id: string;
};

export const useGetCustomRoleById = createQueryHook<
  UseGetCustomRoleByIdArgs,
  GetCustomRoleByIdResponseRow[],
  GetCustomRoleByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.customRole.customRoleById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ custom_role: data }),
  graphqlDocument: GetCustomRoleByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
  // Mounted by both the custom-role settings page and the breadcrumb-label
  // hook concurrently; cache-first lets Apollo dedup the identical query (the
  // factory default 'no-cache' defeats dedup and the resulting console.warn is
  // promoted to fatal by the web vitest setup).
  graphqlFetchPolicy: 'cache-first',
});
